export const environment = {
    production: false,
    apiUrl: 'https://dev.api.tridimo.de/api/',
    webSocket: 'https://dev.api.tridimo.de',
    useTokenAuth: true,
    syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1JGaF1cXmhKYVJ/WmFZfVhgdVVMYV9bQXNPMyBoS35RcEVgWH1fcHVWQ2VUUkZxVEFf'
};